"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.LoadingSpinner = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var LoadingSpinner_module_scss_1 = __importDefault(require("./LoadingSpinner.module.scss"));
/**
 * {@link https://cultureamp.design/components/loading-spinner/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-loading-spinner--default-story Storybook}
 */
var LoadingSpinner = function (_a) {
    var _children = _a.children, // not used
    _b = _a.accessibilityLabel, // not used
    accessibilityLabel = _b === void 0 ? "Loading" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, classNameOverride = _a.classNameOverride, props = __rest(_a, ["children", "accessibilityLabel", "size", "classNameOverride"]);
    return (react_1["default"].createElement("div", __assign({ "data-automation-id": "loading-spinner", className: (0, classnames_1["default"])(LoadingSpinner_module_scss_1["default"].wrapper, classNameOverride), role: "status" }, props),
        react_1["default"].createElement("span", { className: LoadingSpinner_module_scss_1["default"].visuallyHidden }, accessibilityLabel),
        size === "md" ? (react_1["default"].createElement("svg", { className: LoadingSpinner_module_scss_1["default"].spinner, "aria-hidden": "true", viewBox: "0 0 48 48", width: 48, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1["default"].createElement("circle", { cx: "24", cy: "24", r: "22.5", stroke: "currentColor", strokeWidth: "3", strokeOpacity: "0.3" }),
            react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", 
                /* eslint-disable max-len */
                d: "M46.5 24c.8284 0 1.5049-.6734 1.4539-1.5002C47.21 10.44 37.5601.789989 25.5003.0461639 24.6734-.004835 24 .671607 24 1.50003c0 .82843.6738 1.49444 1.5002 1.55277 10.4023.73424 18.7128 9.0447 19.447 19.447C45.0056 23.3262 45.6716 24 46.5 24z" }))) : (react_1["default"].createElement("svg", { className: LoadingSpinner_module_scss_1["default"].spinner, "aria-hidden": "true", viewBox: "0 0 24 24", width: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1["default"].createElement("circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeWidth: "2", strokeOpacity: "0.3" }),
            react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor", 
                /* eslint-disable max-len */
                d: "M21.0564 13c.5076 0 .9377-.3851.9431-.8926.0004-.0358.0005-.0716.0005-.1074 0-5.52285-4.4771-10-10-10-.0359 0-.0718.00019-.1076.00057-.5076.00535-.8926.43552-.8926.94308v.11543C10.9998 3.59163 11.4675 4 12 4c4.4183 0 8 3.58172 8 8 0 .5324.4083 1 .9407 1h.1157z" })))));
};
exports.LoadingSpinner = LoadingSpinner;
exports.LoadingSpinner.displayName = "LoadingSpinner";
//# sourceMappingURL=LoadingSpinner.js.map